import * as React from 'react';
import cx from 'classnames';

import Container, { Props as ContainerProps } from 'components/Container';

import './styles/CenteredContainer.scss';

type Props = {
  children: React.ReactNode;
  className?: string;
} & ContainerProps;

function CenteredContainer(props: Props) {
  const { children, className, ...others } = props;

  return (
    <div className={cx('CenteredContainer', className)}>
      <div className="CenteredContainer-wrap">
        <Container {...others}>{children}</Container>
      </div>
    </div>
  );
}

export default CenteredContainer;
